import React, { useEffect, useState } from "react"
import { ScrollView, TouchableOpacity, TouchableWithoutFeedback, View } from "react-native"
import styles from "./styles"
import CustomBottomModal from "@Components/Modal/CustomBottomModal/CustomBottomModal"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { RFValue } from "react-native-responsive-fontsize"
import { Button } from "@Components/CustomButton/Button"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import { MultilineInput } from "@Components/Input/MutlilineInput"
import { ForumService } from "@Services/Knowledge/SavoirEtre/Forum.Service"
import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { Spacer } from "@Components/Space"
import { CustomTouchable } from "@Components/FollowUp/Reminder/CustomTouchable"
import { CustomRadioGroup } from "@Components/CustomRadioGroup/CustomRadioGroup"
import { message } from "@Constants/constant"
import { EducatifDiagnoseService } from "@Services/EducatifDiagnose.Service"
import { InputGroup } from "@Components/Input/InputGroups"
import { Keyboard } from "react-native"

const ModalCreateForum = (props) => {
    const { toggleModal, openModal, defaultAxisId, setUpdateForumList } = props
    const [subject, setSubject] = useState("")
    const [content, setContent] = useState("")
    const [creating, setCreating] = useState(false)
    const [loading, setLoading] = useState(false)
    const [axis, setAxis] = useState([])
    const [activeAxis, setActiveAxis] = useState(defaultAxisId)
    const fetchAllAxis = () => {
        setLoading(true)
        EducatifDiagnoseService.getAllAxis()
            .then((response) => {
                const data = response.data.data?.items
                const axisOnly = data?.slice(0, 4)
                if (data) {
                    setAxis(axisOnly)
                }
                setLoading(false)
            })
            .catch((e) => {
                ShowToast({ type: "error", message: message.serverError })
                setLoading(false)
            })
    }
    const clearInput = () => {
        setSubject("")
        setContent("")
    }

    useEffect(() => {
        fetchAllAxis()
    }, [])

    const handleCreateForum = () => {
        setCreating(true)
        const payload = {
            subject: subject,
            content: content,
            axisId: activeAxis
        }

        ForumService.createForum(payload)
            .then(() => {
                setCreating(false)
                ShowToast({
                    type: "success",
                    message: "Sujet créé avec succès."
                })
                clearInput()
                setUpdateForumList((prev) => !prev)
                toggleModal()
            })
            .catch(() => {
                ShowToast({
                    type: "error",
                    message: "Une erreur est survenue."
                })
                setCreating(false)
            })
    }

    const disableCreationBtn = subject.trim().length < 3 || content.trim().length < 3 || !activeAxis

    return (
        <CustomBottomModal toggleModal={toggleModal} open={openModal}>
            {/* <TouchableOpacity activeOpacity={1} onPress={Keyboard.dismiss} style={{ height: "90%" }}> */}
            <ScrollView style={{ height: "90%" }}>
                <BreeSerifText fontSize={19} color={baseColors.black}>
                    Créer un sujet de discussion
                </BreeSerifText>

                <Spacer height={8} />

                <OpenSansText fontSize={16}>Remplissez tous les champs ci-dessous</OpenSansText>

                <Spacer height={20} />

                <OpenSansText fontSize={16} defaultFontFamily={baseFontFamily.OpenSansSemiBold}>
                    Type de sujet
                </OpenSansText>

                <Spacer />

                <CustomRadioGroup active={activeAxis} handleClick={(axs) => setActiveAxis(axs)} data={axis} />

                <View style={styles.formContainer}>
                    <InputGroup
                        onChange={(text) => setSubject(text)}
                        placeholder={"Tapez votre texte"}
                        label={"Titre du sujet de discussion"}
                    />

                    <OpenSansText fontWeight={"bold"} fontSize={16}>
                        Votre message
                    </OpenSansText>

                    <MultilineInput
                        label={"Votre message"}
                        placeholder="Tapez votre texte"
                        value={content}
                        onChange={(text) => setContent(text)}
                        height={100}
                    />
                </View>

                <Button
                    disabled={disableCreationBtn || creating}
                    loading={creating}
                    onPress={handleCreateForum}
                    text="Créer la discussion"
                    width="70%"
                    backgroundColor={baseColors.green.primary}
                    labelColor={"white"}
                />
            </ScrollView>
        </CustomBottomModal>
    )
}

export default ModalCreateForum
